/**
 * @param actionType
 * Appends REQUEST async action type
 */
export const REQUEST = (actionType: string): string => `${actionType}_PENDING`;

/**
 * @param actionType
 * Appends SUCCESS async action type
 */
export const SUCCESS = (actionType: string): string => `${actionType}_FULFILLED`;

/**
 * @param actionType
 * Appends FAILURE async action type
 */
export const FAILURE = (actionType: string): string => `${actionType}_REJECTED`;
